import Swal from "sweetalert2";

const SWAL_Z_INDEX = 10080;

/** SweetAlert2 above `.cms-app-modal` (10050) and stack-top (10070). */
function pinSwalAboveAppModal(popup) {
  const container =
    popup?.closest?.(".swal2-container") ||
    document.querySelector(".swal2-container.cms-swal-above-app-modal:last-of-type") ||
    document.querySelector(".swal2-container:last-of-type");

  if (container) {
    container.classList.add("cms-swal-above-app-modal");
    container.style.setProperty("z-index", String(SWAL_Z_INDEX), "important");
  }
}

export const SWAL_ABOVE_APP_MODAL = {
  zIndex: SWAL_Z_INDEX,
  customClass: {
    container: "cms-swal-above-app-modal",
  },
  didOpen: (popup) => {
    pinSwalAboveAppModal(popup);
  },
};

export const SwalAboveAppModal = Swal.mixin(SWAL_ABOVE_APP_MODAL);

export function swalAboveAppModal(options = {}) {
  const { customClass: userClass = {}, didOpen: userDidOpen, ...rest } = options;
  return {
    ...SWAL_ABOVE_APP_MODAL,
    ...rest,
    customClass: {
      ...SWAL_ABOVE_APP_MODAL.customClass,
      ...userClass,
    },
    didOpen: (popup) => {
      pinSwalAboveAppModal(popup);
      if (typeof userDidOpen === "function") {
        userDidOpen(popup);
      }
    },
  };
}
